export default __webpack_public_path__ + "static/media/taxi.9a02abc6.svg";